import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {FilterMenu} from "../filterMenu";
import {complainStatuses} from "../../app/config";
import {useEffect} from "react";

export const pageSizes = [
    {
        value: 6,
        sec: '6',
        text: '6',
        disabled: false,
    },
    {
        value: 25,
        sec: '25',
        text: '25',
        disabled: false,
    },
    {
        value: 50,
        sec: '50',
        text: '50',
        disabled: false,
    },
    {
        value: 100,
        sec: '100',
        text: '100',
        disabled: false,
    },
]

const TablePagination = props => {
    const {t} = useTranslation('Common');
    
    return (
        <div
            className={`fk-pagination${
                !props.filter.hasPrevious ? " --flex-end" : ""
            }`}
        >
            {props.filter.hasPrevious && (
                <Button
                    className="fk-button fk-button--outline"
                    onClick={props.handlePreviousPage}
                >
                    {t('previous')}
                </Button>
            )}
            {props.showOnPage &&
                <div style={{paddingRight: 36, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                    <FilterMenu
                        disableClear
                        label={"Show"}
                        options={pageSizes}
                        selected={pageSizes.find(i => i.value === props.filter.pageSize)}
                        onChange={(option) => props.showOnPage(option.value)}
                    />
                </div>
            }
            {props.filter.hasNext && (
                <Button
                    className="fk-button fk-button--primary"
                    onClick={props.handleNextPage}
                >
                    {t('next')}
                </Button>
            )}
        </div>
    );
};

export default TablePagination;